import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import pageReducer from './pageSlice';
import adminReducer from './adminUserSlice';
import adminsReducer from './adminsSlice';
import doctorsPageReducer from './doctorsSlice';
import clinicsPageReducer from './clinicsSlice';
import membersPageReducer from './membersSlice';
import memberPageReducer from './memberSlice';
import questionsPageReducer from './medicalQuestionsSlice';
import alertsPageReducer from './alertsSlice';
import appReducer from './appSlice';
import faqReducer from './faqSlice';
import nutritionistsReducer from './nutritionistsSlice';
import recommendationsReducer from './recommendationSlice';
import foodsReducer from './foodsSlice';
import appointmentsReducer from './appointmentsSlice';
import chatReducer from './chatSlice';

export const store = configureStore({
  reducer: {
    app: appReducer,
    page: pageReducer,
    admin: adminReducer,
    admins: adminsReducer,
    doctors: doctorsPageReducer,
    clinics: clinicsPageReducer,
    members: membersPageReducer,
    member: memberPageReducer,
    questions: questionsPageReducer,
    alerts: alertsPageReducer,
    faq: faqReducer,
    nutritionists: nutritionistsReducer,
    recommendations: recommendationsReducer,
    foods: foodsReducer,
    appointments: appointmentsReducer,
    chat: chatReducer
  }
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
